import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["ratingInput"]

    connect() {
        this.selectedRating = 0
        this.hoveredRating = 0
    }

    selectStar(event) {
        const rating = parseInt(event.currentTarget.dataset.star)
        this.selectedRating = rating
        this.ratingInputTarget.value = rating
        this.updateStarDisplay()

        this.element.classList.remove('star-rating--error')
        this.element.classList.add('star-rating--selected')
    }

    hoverStar(event) {
        const rating = parseInt(event.currentTarget.dataset.star)
        this.hoveredRating = rating
        this.updateStarDisplay(rating)
    }

    resetHover() {
        this.hoveredRating = 0
        this.updateStarDisplay()
    }

    updateStarDisplay(hoverRating = null) {
        const stars = this.element.querySelectorAll('.star-rating__star')
        const activeRating = hoverRating || this.selectedRating

        stars.forEach((star, index) => {
            const starNumber = index + 1
            const starIcon = star.querySelector('.star-rating__icon')

            if (starNumber <= activeRating) {
                star.classList.add('star-rating__star--active')
                starIcon.classList.add('star-rating__icon--filled')
            } else {
                star.classList.remove('star-rating__star--active')
                starIcon.classList.remove('star-rating__icon--filled')
            }

            if (hoverRating && starNumber <= hoverRating) {
                star.classList.add('star-rating__star--hover')
            } else {
                star.classList.remove('star-rating__star--hover')
            }
        })
    }
    validate() {
        if (this.selectedRating === 0) {
            this.element.classList.add('star-rating--error')
            return false
        }
        return true
    }
}
